module.exports = __webpack_public_path__ + "static/media/toolbar-full-screen.8a3d71dd.svg";